// extracted by mini-css-extract-plugin
export default {"expired-page":"style_expired-page__of5Zw","wrapper":"style_wrapper__c4kq6","footer":"style_footer__4DPk5","copyright":"style_copyright__7HTRf"};